const SidePanelConstants = {
  ACTIVE: "Active",
  ADAPTIVE: "adaptiveSegments",
  ALL: "all",
  ALL_TECHNOLOGY_TYPE: "ALLTYPES",
  ALLOWLIST: "allowList",
  AND: "AND",
  APP: "app",
  AUDIO_VIDEO_AUDIO: "VAUD",
  AUDIO_VIDEO_CONTENT_INITIATION: "VCON",
  AUDIO_VIDEO_LINEAR_FORMAT: "VLIN",
  AUDIO_VIDEO_PLACEMENT: "VPLC",
  AUDIO_VIDEO_PLAYER_SIZE: "VPSZ",
  AUDIO_VIDEO_SKIPPABILITY: "VSKP",
  AUTO_ADJUST: "AUTO_ADJUST",
  BETWEEN: "between",
  BLOCKLIST: "blockList",
  CHECKED: "checked",
  COUNTRY_DMA: "countryDma",
  CREATIVES: "creatives",
  CONTEXTUAL_GROUPS: "contextualGroups",
  DATA_PIXELS: "Data Pixels",
  DAYS: "days",
  DOMAIN: "domain",
  EQUAL_TO: "=",
  EVENT_PIXELS: "Event Pixels",
  EXCLUDE: "exclude",
  FIRST_PARTY: "firstPartyAudience",
  FIXED: "FIXED",
  FLOOR: "FLOOR",
  GEOFENCE: "GEOFENCE",
  GEOFENCE_TARGETING: "geofence",
  GREATER_THAN: ">",
  GROUP_1: "Group 1",
  HOURS: "hours",
  INACTIVE: "Inactive",
  INCLUDE: "include",
  INCLUDE_COLOR: "#4F7226",
  INVENTORY: "inventory",
  INVENTORY_SITELIST: "sitelist",
  INVENTORY_SUPPLY: "supply",
  IP: "ip",
  IP_ADDRESSES: "ipAddresses",
  LESS_THAN: "<",
  LOCATION_CITY: "CITY",
  LOCATION_COUNTRY: "COUNTRY",
  LOCATION_DMAX: "DMAX",
  LOCATION_REGION: "REGION",
  LOCATION_REGN: "REGN",
  LOCATION_REGNDMA: "REGNDMA",
  MARKETPLACE: "MARKETPLACE",
  MIN_OPACITY: 0.3,
  NEVER_END_DATE_YEAR: 2999,
  NO_WEIGHTING: "NONE",
  OPEN_EXCHANGES_SSP: "OPEN EXCHANGES & SSP",
  OR: "OR",
  PAGE_SIZE: 100,
  PIXEL_ADAPTIVE: "dynamic",
  PIXEL_ADAPTIVE_SEGMENT: "adaptive",
  PIXEL_DATA: "data",
  PIXEL_EVENT: "event",
  PIXEL_SEGMENT: "segment",
  PIXEL_THIRD_PARTY: "thirdparty",
  POSTAL: "postal",
  POSTAL_CODES: "postalCodes",
  SEARCH_CONTAIN: "contain",
  SEARCH_EXACTLY: "exactly",
  SORT_DESCENDING: -1,
  STANDARD: "STANDARD",
  STANDARD_SEGMENTS: "Standard Segments",
  SUPPLY_OPEN: "supply_sources",
  SUPPLY_OPEN_MARKETPLACES: "supply_sources_marketplaces",
  SUPPLY_PMPE_DEAL_GROUP: "deal_groups",
  SUPPLY_PMPE_DEALS: "deals",
  SUPPLY_SOURCE: "supply_source",
  TARGETING: "targeting",
  TARGETING_AUDIENCE: "audience",
  TARGETING_AUDIO_VIDEO: "audioVideo",
  TARGETING_CONTEXTUAL: "contextual",
  TARGETING_GEOGRAPHY: "geography",
  TARGETING_LOCATION: "location",
  TARGETING_TECHNOLOGY: "technology",
  TECHNOLOGY_BROWSER: "BSER",
  TECHNOLOGY_BROWSER_LANGUAGE: "BRLG",
  TECHNOLOGY_CONNECTION_SPEED: "CSPD",
  TECHNOLOGY_DEVICE_MODEL: "DVMD",
  TECHNOLOGY_DEVICE_TYPE: "DVCE",
  TECHNOLOGY_INVENTORY_TYPE: "INVT",
  TECHNOLOGY_ISP: "ISPX",
  TECHNOLOGY_OS_VERSION: "OSXX",
  THIRD_PARTY: "thirdPartyAudience",
  TOP20: "top20",
  VIEW_SELECTOR_HEIGHT: 47,
  WEEKS: "weeks",
  POSTAL_CODES_IP_LIMIT: 100000,
  POSTAL_CODES_IP_ADDRESSES_LIMIT: 100,
  POSTAL_CODES_GUIDELINE_LINK:
    "https://support.infillion.com/s/article/How-to-activate-postal-code-targeting",
  IP_ADDRESSES_GUIDELINE_LINK:
    "https://support.infillion.com/s/article/Geography-Targeting",
};

export default SidePanelConstants;
